import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  MANUAL_SUBSCRIPTION_PAGE: `${cleanedFilename(
    __filename,
  )}-manual-subscription-page`,
};
